module.exports = __webpack_public_path__ + "static/who-5025ed497f9320705e6d80359e4fd402.jpg";